import { CampaignSchema } from 'pages/publicity/sidebars/ManageCampaignSidebar/schema'
import { api_dominios } from 'services/apis'
import { ApiPubliResponse, ImageType, PubliCardType } from 'types/publicidade'
import changeFilterToString, { FilterValuesType } from 'utils/changeFilterToString'

const URL = '/campanha'

// Filtro utilizado para listar campanhas publicitárias
interface PubliListFilter {
  nm_campanha?: string
  st_status?: string
  dt_iv_campanha?: Date
  dt_fv_campanha?: Date
  nm_menu?: string
}

// Função para buscar a lista de campanhas com filtro opcional
export const getPubliList = async (filtro?: PubliListFilter): Promise<PubliCardType[]> => {
  const params = changeFilterToString(filtro as FilterValuesType)
  const response = await api_dominios.get<ApiPubliResponse>(`${URL}?${params}`)
  return response.data.data
}

// Estrutura do payload esperado pela API para criar/atualizar campanhas
export interface CampaignData {
  nm_campanha: string
  dt_iv_campanha: string // data e hora de início da campanha, formato ISO
  dt_fv_campanha: string // data e hora de fim da campanha, formato ISO
  st_status: string
  ds_descricao: string
  nm_menu: string
  imagem_banner_desktop: ImageType
  imagem_banner_mobile: ImageType
  id_conpv082: number
}

// Função que converte os dados do formulário (CampaignSchema) no formato adequado para a API
function getCampaignData(data: CampaignSchema): CampaignData {
  return {
    nm_campanha: data.nm_campanha,
    dt_iv_campanha: data.dt_campanha.dt_iv_campanha.toISOString(),
    dt_fv_campanha: data.dt_campanha.dt_fv_campanha.toISOString(),
    st_status: data.st_status,
    ds_descricao: data.ds_descricao,
    nm_menu: data.nm_menu,
    imagem_banner_desktop: data.imagem_banner_desktop as ImageType, // Garante que o tipo seja ImageType
    imagem_banner_mobile: data.imagem_banner_mobile as ImageType, // Garante que o tipo seja ImageType
    id_conpv082: data.id_conpv082
  }
}

// Função para criar uma nova campanha
export const postPubliCard = async (data: CampaignSchema): Promise<void> => {
  await api_dominios.post(URL, getCampaignData(data))
}

// Função para atualizar uma campanha existente
export const putPubliCard = async (data: CampaignSchema): Promise<void> => {
  await api_dominios.put(URL, getCampaignData(data))
}

// Função para deletar uma campanha pelo ID
export const deletePubliCard = async (id_conpv082: number): Promise<void> => {
  await api_dominios.delete(`${URL}?ID_CONPV082=${id_conpv082}`)
}
